import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { formatDate } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader, usePagination, ButtonModifier } from "../../../components";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Button,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilHasilStockOpname = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch, setting } = useContext(AuthContext);
  const [noBukti, setNoBukti] = useState("");
  const [tglHasilStockOpname, setTglHasilStockOpname] = useState("");
  const [tglHasilStockOpnameDate, setTglHasilStockOpnameDate] = useState();
  const [kodeCOA, setKodeCOA] = useState("");
  const [isPost, setIsPost] = useState("");

  const [hasilStockOpnameChildData, setHasilStockOpnameChildData] = useState(
    [],
  );
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  let today = new Date();
  let isEditableManager = user.tipeUser !== "ADMIN" && isPost === false;
  let isEditableAdmin = true;
  let isEditable = isEditableManager || isEditableAdmin;

  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(1);
  const PER_PAGE = 20;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Get current posts
  const indexOfLastPost = page * PER_PAGE;
  const indexOfFirstPost = indexOfLastPost - PER_PAGE;
  const currentPosts = hasilStockOpnameChildData.slice(
    indexOfFirstPost,
    indexOfLastPost,
  );

  const count = Math.ceil(hasilStockOpnameChildData.length / PER_PAGE);
  const _DATA = usePagination(hasilStockOpnameChildData, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  useEffect(() => {
    getHasilStockOpnameById();
  }, []);

  const getHasilStockOpnameById = async () => {
    setLoading(true);
    const response = await axios.post(`${tempUrl}/hasilStockOpnames/${id}`, {
      _id: user.id,
      token: user.token,
    });
    setNoBukti(response.data.noBukti);
    setTglHasilStockOpname(response.data.tglHasilStockOpname);
    setTglHasilStockOpnameDate(new Date(response.data.tglHasilStockOpname));
    setKodeCOA(response.data.coa);
    setIsPost(response.data.isPost);
    const response2 = await axios.post(
      `${tempUrl}/hasilStockOpnamesChildByHasilStockOpname`,
      {
        hasilStockOpnameId: response.data.id,
        kodeCabang: user.cabang.id,
        _id: user.id,
        token: user.token,
      },
    );
    setHasilStockOpnameChildData(response2.data);
    setLoading(false);
  };

  const deleteHasilStockOpname = async (id) => {
    setLoading(true);
    try {
      await axios.post(`${tempUrl}/deleteHasilStockOpname/${id}`, {
        _id: user.id,
        token: user.token,
      });
      navigate("/daftarHasilStockOpname");
    } catch (error) {
      alert(error.response.data.message);
    }
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Transaksi</h3>
      <h5 style={{ fontWeight: 400 }}>Hasil Stock Opname</h5>
      <hr />
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate("/daftarHasilStockOpname")}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>
      <Box sx={buttonModifierContainer}>
        {isEditable && (
          <>
            <ButtonModifier
              id={id}
              kode={"test"}
              addLink={null}
              editLink={`/daftarHasilStockOpname/hasilStockOpname/${id}/edit`}
              deleteUser={deleteHasilStockOpname}
              nameUser={noBukti}
            />
          </>
        )}
      </Box>
      <Form>
        <Card>
          <Card.Header>Hasil Stock Opname</Card.Header>
          <Card.Body>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. Bukti :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control required value={noBukti} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. Stock Opname :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={tglHasilStockOpname}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Kode COA :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={`${kodeCOA.kodeCOA} - ${kodeCOA.namaCOA}`}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Form>
      <Box sx={tableContainer}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead
              sx={{
                "& .MuiTableCell-head": {
                  color: "white",
                  backgroundColor: "#1976d2",
                },
              }}
            >
              <TableRow>
                <TableCell>Stok</TableCell>
                <TableCell>Quantity Sistem</TableCell>
                <TableCell>Hasil SO</TableCell>
                <TableCell>Quantity Selisih</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {currentPosts.map((child) => (
                <TableRow key={child.id}>
                  <TableCell>
                    {child.stok
                      ? `${child.stok.kodeStok} - ${child.stok.namaStok}`
                      : "-"}
                  </TableCell>
                  <TableCell>
                    {Number(child.quantityLama || 0).toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell>
                    {Number(child.quantityBaru || 0).toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell>
                    {Number(child.quantitySelisih || 0).toLocaleString("de-DE")}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={count}
          page={page}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Container>
  );
};

export default TampilHasilStockOpname;

const buttonModifierContainer = {
  mt: 4,
  mb: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};
